<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[{'hauteur-brief-filtre': errors.length === 0},
        {'hauteur-brief-filtre-errors': errors.length > 0}]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.patrimoine')">
            <b-input v-model="newCritereRecherche.lignesCommandeRegroupementLibelle">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.typeProduit')">
            <b-input v-model="newCritereRecherche.lignesCommandeLibelle">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeEcheances.filtre.categorieVente')"
                      :items="categorieProduit"
                      v-model="categorieVenteSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.codeDossier')">
            <b-input v-model="newCritereRecherche.codeDossier ">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.theme')">
            <qd-taginput v-model="newCritereRecherche.themes"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <libelle-tag-input
            v-model="newCritereRecherche.etats"
            :label="$t('listeEcheances.filtre.etats')"
            :items="constantes.COMMANDE_ETAT">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('listeEcheances.filtre.commercial')"
                        :blocked="userIsCommercialBlocked"
                        v-model="commercialSelected"
                        :items="listeCommercial">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('listeEcheances.filtre.assistant')"
                        v-model="assistantSelected"
                        :items="listeAssistant">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.annonceur')">
            <qd-taginput
              v-model="annonceurSelected"
              :data="filteredAnnonceur"
              autocomplete
              :allow-new="false"
              field="nomCommercial"
              icon="magnify"
              type="is-primary"
              @select="filteredAnnonceur = []"
              @typing="getFilteredAnnonceur">
              <template slot-scope="props">
                {{ props.option.nomWithAdresseAndCompteComptable }}
              </template>
              <template slot="empty">
                {{$t('general.autocomplete.noRslt')}}
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.payeur')">
            <qd-taginput
              v-model="payeurSelected"
              :data="filteredPayeur"
              autocomplete
              :allow-new="false"
              field="nomCommercial"
              icon="magnify"
              type="is-primary"
              @select="filteredAnnonceur = []"
              @typing="getFilteredPayeur">
              <template slot-scope="props">
                {{ props.option.nomWithAdresseAndCompteComptable }}
              </template>
              <template slot="empty">
                {{$t('general.autocomplete.noRslt')}}
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <agence-tag-input
                      :label="$t('listeEcheances.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesIds">
          </agence-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('listeEcheances.filtre.groupe')"
            dropdown="top"
            v-model="groupeSelected"
            :typologie="this.constantes.TYPOLOGIE_GROUPE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('listeEcheances.filtre.enseigne')"
            dropdown="top"
            v-model="enseigneSelected"
            :typologie="this.constantes.TYPOLOGIE_ENSEIGNE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.facturationFaite')">
            <b-select v-model="newCritereRecherche.facturationFaite">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.factureParEmail')">
            <b-select v-model="newCritereRecherche.factureParEmail">
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.codeCommande')">
            <b-input v-model="newCritereRecherche.code">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <input-periode
            v-model="newCritereRecherche.dateCommande"
            :label="$t('listeEcheances.filtre.dateCommande')"
            orientation="top">
          </input-periode>
       </div>
       <div class="column is-12 pdb-0">
          <input-periode
            v-model="newCritereRecherche.dateCampagne"
            :label="$t('listeEcheances.filtre.dateCampagne')"
            orientation="top">
         </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.estinterne')">
            <b-select v-model="newCritereRecherche.interne" expanded>
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
           </b-select>
         </b-field>
       </div>
       <div class="column is-12 pdb-0" v-if="moduleIndexationCommandeActive">
          <b-field :label="$t('listeDevis.filtre.estIndexable')">
            <b-select v-model="newCritereRecherche.estIndexable" expanded>
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false">{{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.estSigne')">
            <b-select v-model="newCritereRecherche.estSigne" expanded>
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
         </b-field>
       </div>
       <div class="column is-12 pdb-0" v-if="moduleSignatureElectroniqueActive">
          <b-field :label="$t('listeEcheances.filtre.estSigneElectroniquement')">
            <b-select v-model="newCritereRecherche.estSigneElectroniquement" expanded>
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
         </b-field>
       </div>
        <div v-if="modulePresseActive" class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.regleFacturation')">
            <qd-taginput
              v-if="regleFacturationTags"
              v-model="regleFacturationSelected"
              :data="regleFacturationTags"
              type="is-primary"
              icon="magnify"
              field="libelle"
              autocomplete
              open-on-focus
              @typing="getFilteredRegleFacturationTags"
              @input="getRegleFacturationTag">
            </qd-taginput>
          </b-field>
        </div>
        <div v-if="modulePresseActive" class="column is-12 pdb-0">
          <b-field :label="$t('listeEcheances.filtre.parutions')">
            <qd-taginput
              v-model="parutionsSelected"
              :data="filteredParutions"
              :loading="isFetchingParutions"
              :disabled="disabledFilterParution"
              icon="magnify"
              type="is-primary"
              field="code"
              autocomplete
              @typing="getfilteredParutions">
              <template slot-scope="props">
                {{ `${props.option.code} - ${props.option.nomParution}` }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingParutions">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('general.button.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';
import { COMMANDE_ETAT } from '@/configuration/devisConf';
import { getAll } from '@/api/tiers';
import {
  TIERS_TYPE_CLIENT,
  TYPOLOGIE_ENSEIGNE,
  TYPOLOGIE_GROUPE,
  TIERS_SOUS_TYPE_AUCUN,
} from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { SET_CRITERE } from '@/store/modules/bafCommande-mutation-type';
import genererCritereRechercheCommandeAFacturer
  from '@/services/devisCommandes/genererCritereRechercheCommandeAFacturer';
import { ASSISTANT_COMMERCIAL, COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import queryTiersTagInput from '@/components/general/tagInput/queryTiersTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import userTagInput from '@/components/general/tagInput/userTagInput';
import inputPeriode from '@/components/general/inputPeriode';
import initialUsers from '@/services/general/filters/filterinitUsers';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import { getAll as getAllParutions } from '@/api/presse/parution';
import moment from 'moment';

const Echeanciers = createNamespacedHelpers('echeancier');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  name: 'filtreEcheanceCommandeAFacturer',
  props: {
    disabledFilterParution: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      errors: [],
      annonceurSelected: [],
      filteredAnnonceur: [],
      filteredPayeur: [],
      payeurSelected: [],
      newCritereRecherche: null,
      isFetching: false,
      constantes: {
        TYPOLOGIE_GROUPE,
        TYPOLOGIE_ENSEIGNE,
        COMMANDE_ETAT,
      },
      categorieVenteSelected: [],
      groupeSelected: [],
      enseigneSelected: [],
      listeCommercial: [],
      commercialSelected: [],
      listeAssistant: [],
      assistantSelected: [],
      regleFacturationSelected: [],
      regleFacturationTags: null,
      parutionsSelected: [],
      isFetchingParutions: false,
      filteredParutions: [],
    };
  },
  components: {
    userTagInput,
    libelleTagInput,
    agenceTagInput,
    queryTiersTagInput,
    errorMsgComponent,
    inputPeriode,
  },
  computed: {
    ...Echeanciers.mapGetters({
      critereRecherche: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    blocageFiltreCommercial() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercialBlocked() {
      return (this.userIsCommercial && this.blocageFiltreCommercial);
    },
    userIsCommercial() {
      return (this.user.profil === COMMERCIAL);
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
    modulePresseActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    reglesFacturation() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.regleFacturation)
        .filter(regle => regle.societeId === this.societeActiveId);
    },
    echeancesAFacturerAAIsActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.echeancesAFacturerAA.key);
    },
    moduleSignatureElectroniqueActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.signatureElectronique.key);
    },
    moduleIndexationCommandeActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    ...Echeanciers.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    getFilteredAnnonceur: debounce(async function getAnnonceur(search) {
      this.filteredAnnonceur = [];
      if (!search) return;
      try {
        const annonceur = (await getAll(
          {
            query: {
              auto: search,
              sousType: [TIERS_SOUS_TYPE_AUCUN],
              type: TIERS_TYPE_CLIENT,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items;
        annonceur.forEach((tiers) => {
          tiers.nomWithAdresseAndCompteComptable = tiers.code + ' - ' + tiers.nomCommercial;
          if (adressFullStringGetter(tiers.adressePostale, false) !== '') {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + adressFullStringGetter(tiers.adressePostale, false);
          }
          if (tiers.compteComptable) {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + tiers.compteComptable;
          }
        });
        this.filteredAnnonceur = annonceur.filter((tiersAnnonceur) => {
          return !this.annonceurSelected.map(annonceurSelected => annonceurSelected.id)
            .includes(tiersAnnonceur.id);
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredPayeur: debounce(async function getAnnonceur(search) {
      this.filteredPayeur = [];
      if (!search) return;
      try {
        const payeur = (await getAll(
          {
            query: {
              auto: search,
              sousType: [TIERS_SOUS_TYPE_AUCUN],
              type: TIERS_TYPE_CLIENT,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items;
        payeur.forEach((tiers) => {
          tiers.nomWithAdresseAndCompteComptable = tiers.code + ' - ' + tiers.nomCommercial;
          if (adressFullStringGetter(tiers.adressePostale, false) !== '') {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + adressFullStringGetter(tiers.adressePostale, false);
          }
          if (tiers.compteComptable) {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + tiers.compteComptable;
          }
        });
        this.filteredPayeur = payeur.filter((tiersPayeur) => {
          return !this.payeurSelected.map(payeurSelected => payeurSelected.id)
            .includes(tiersPayeur.id);
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getRegleFacturationTag() {
      this.regleFacturationTags = this.reglesFacturation.filter((regleFacturation) => {
        return !this.regleFacturationSelected.map(r => r.id).includes(regleFacturation.id);
      });
    },
    getFilteredRegleFacturationTags(text) {
      this.getRegleFacturationTag();
      this.regleFacturationTags = this.regleFacturationTags.filter((regleFacturation) => {
        return regleFacturation.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getfilteredParutions: debounce(async function getParutions(search) {
      this.filteredParutions = [];
      if (!search) return;
      this.isFetchingParutions = true;
      try {
        const parutions = (await getAllParutions({
          query: {
            auto: search,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        this.filteredParutions = parutions.filter((produit) => {
          return !this.parutionsSelected.map(p => p.id).includes(produit.id);
        });
        this.isFetchingParutions = false;
      } catch (e) {
        this.isFetchingParutions = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    appliquerCritere() {
      this.errors = [];
      this.newCritereRecherche.annonceursId = this.annonceurSelected;
      this.newCritereRecherche.payeursId = this.payeurSelected;
      this.newCritereRecherche.groupeIds = this.groupeSelected;
      this.newCritereRecherche.enseigneIds = this.enseigneSelected;
      this.newCritereRecherche.categorieVente = this.categorieVenteSelected;
      this.newCritereRecherche.commercialIds = this.commercialSelected.map((c) => {
        return c.id;
      });
      this.newCritereRecherche.assistantIds = this.assistantSelected.map((c) => {
        return c.id;
      });
      if (this.modulePresseActive) {
        this.newCritereRecherche.regleFacturationIds = this.regleFacturationSelected;
        this.newCritereRecherche.parutionsIds = this.parutionsSelected;
      }
      const critere = cloneDeep(this.newCritereRecherche);
      critere.etats = critere.etats.map(etat => etat.code);
      this.setCritereRecherche(critere);
      this.$emit('recherche');
    },
    async viderCritere() {
      const critere = cloneDeep(genererCritereRechercheCommandeAFacturer(false));
      critere.etats = critere.etats.map(etat => COMMANDE_ETAT.find(e => e.code === etat));
      this.newCritereRecherche = critere;
      if (this.echeancesAFacturerAAIsActive) {
        this.newCritereRecherche.datePrevisionnelleFacturation = {
          dateDebut: (moment().startOf('year')).toDate(),
          dateFin: (moment().endOf('year')).toDate(),
        };
      }
      await updateCritereWithParametreInterne(this.newCritereRecherche);
      if (this.newCritereRecherche.commercialIds) {
        this.commercialSelected = this.newCritereRecherche.commercialIds.map(id => {
          return this.listeCommercial.find(c => c.id === id) ?? {};
        });
      }
      if (this.newCritereRecherche.assistantIds) {
        this.assistantSelected = this.newCritereRecherche.assistantIds.map(id => {
          return this.listeAssistant.find(c => c.id === id) ?? {};
        });
      }
      this.annonceurSelected = [];
      this.payeurSelected = [];
      this.groupeSelected = [];
      this.categorieVenteSelected = [];
      this.enseigneSelected = [];
      this.agenceSelected = [];
      this.regleFacturationSelected = [];
      this.parutionsSelected = [];
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const critere = cloneDeep(this.critereRecherche);
        critere.etats = critere.etats.map(etat => COMMANDE_ETAT.find(e => e.code === etat));
        this.newCritereRecherche = critere;
        await this.loadParametreUtilisateur();
        await this.loadParametres([typesParametres.PARAMETRES_KEYS.regleFacturation]);
        await this.loadParametresInterne([
          typesParametres.PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.echeancesAFacturerAA.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.signatureElectronique.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key,
        ]);
        this.annonceurSelected = this.newCritereRecherche.annonceursId;
        this.payeurSelected = this.newCritereRecherche.payeursId;
        this.enseigneSelected = this.newCritereRecherche.enseigneIds;
        this.groupeSelected = this.newCritereRecherche.groupeIds;
        this.categorieVenteSelected = this.newCritereRecherche.categorieVente;

        const users = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif);
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL], this.$i18n.t('listeDevis.filtre.noCommercial'));
        this.listeAssistant = initialUsers(users, [ASSISTANT_COMMERCIAL], this.$i18n.t('listeDevis.filtre.sansAssistant'));

        if (this.critereRecherche.commercialIds) {
          this.commercialSelected = this.listeCommercial.filter((c) => {
            return this.critereRecherche.commercialIds.includes(c.id);
          });
        }
        if (this.critereRecherche.assistantIds) {
          this.assistantSelected = this.listeAssistant.filter((c) => {
            return this.critereRecherche.assistantIds.includes(c.id);
          });
        }
        if (this.modulePresseActive) {
          this.getRegleFacturationTag();
          this.regleFacturationSelected = this.newCritereRecherche.regleFacturationIds;
          this.parutionsSelected = this.critereRecherche.parutionsIds;
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
